import AlertOutlineIcon from '@eduzz/houston-icons/InfoSolid';
import Button from '@eduzz/houston-ui/Button';
import Typography from '@eduzz/houston-ui/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { memo } from 'react';

import { useStyles } from './styles';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: React.ReactNode;
  submitting: boolean;
}

export const ConfirmationModal = memo(({ isOpen, onClose, onConfirm, message, submitting }: IProps) => {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth='xs'>
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.dialogTitleText} size='sm' weight='bold'>
          <AlertOutlineIcon className={classes.alertIcon} size={30} />
          Atenção
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.dialogContent} dividers>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button variant='text' onClick={onClose}>
          Cancelar
        </Button>

        <Button loading={submitting} onClick={onConfirm}>
          {!submitting ? 'Continuar' : 'Aguarde...'}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
